<template>
  <div class="v-radio theme--light primary--text">
    <div class="v-input--selection-controls__input" @click="$emit('input', true)">
      <div class="v-input--selection-controls__ripple primary--text" />
      <i class="v-icon mdi theme--light primary--text" :class="checkedClass" />
    </div>
    <label aria-hidden="true" class="v-label theme--light" style="left: 0; right: auto; position: relative" @click="$emit('input', true)">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: ['value', 'label', 'color'],
  computed: {
    checkedClass() {
      return this.value ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank';
    },
  }
}
</script>
